import { MarketPositions } from './market-positions.model';
import { Currency } from './currency.model';
import { InvestmentZone } from './investment-zone.model';
import { FundDescription } from './fund-description.model';

export class Cluster {
  public id: number;
  public name: string;
  public aum: number;
  public benchmark_id: number;
  public benchmark_name: string;
  public has_original: boolean;
  public has_default_strategies: boolean;
  public has_strategy: boolean;
  public has_investable: boolean;
  public has_protected: boolean;
  public has_update: boolean;
  public is_aggregated: boolean;
  public is_standalone: boolean;
  public is_backtest: boolean;
  public investment_zone: InvestmentZone;
  public currency: Currency;
  public market_positions: MarketPositions;
  public asset_class: string;
  public creation_date: Date;
  public inception_date: Date;
  public last_date: Date;
  public investment_date: Date;
  public last_update: Date;
  public ticker: string;
  public nb_components: number;
  public original_description: FundDescription;
  public benchmark_description: FundDescription;
  public components_description: FundDescription[];
  public original_analysis;
  public investable_analysis;
  public protected_analysis;

  constructor(id: number) {
      this.id = id;
  }

  // initialize current portfolio from JS object
  initFromData(data: any) {
    this.name             = data.name ? data.name : undefined;
    this.aum              = data.aum ? data.aum : undefined;
    this.benchmark_id     = data.benchmark_id ? data.benchmark_id : undefined;
    this.benchmark_name   = data.benchmark_name ? data.benchmark_name : undefined;
    this.has_original     = data.has_original;
    this.has_default_strategies = data.has_default_strategies;
    this.has_strategy     = data.has_strategy;
    this.has_investable   = data.has_investable;
    this.has_protected    = data.has_protected;
    this.has_update       = data.has_update;
    this.is_aggregated    = data.is_aggregated;
    this.is_standalone    = data.is_standalone;
    this.is_backtest      = data.is_backtest;
    this.investment_zone  = data.investment_zone ? data.investment_zone : undefined;
    this.currency         = data.currency ? data.currency : undefined;
    this.market_positions = data.market_positions ? data.market_positions : undefined;
    this.asset_class      = data.asset_class ? data.asset_class : undefined;
    this.ticker           = data.ticker ? data.ticker : undefined;
    this.nb_components    = data.nb_components;
    this.creation_date    = data.creation_date ? new Date(data.creation_date) : undefined;
    this.inception_date   = data.inception_date ? new Date(data.inception_date) : undefined;
    this.last_date        = data.last_date ? new Date(data.last_date) : undefined;
    this.investment_date  = data.investment_date ? new Date(data.investment_date) : undefined;
    this.last_update      = data.last_update ? new Date(data.last_update) : undefined;
    this.original_analysis = data.original_analysis ? data.original_analysis : undefined;
    this.investable_analysis = data.investable_analysis ? data.investable_analysis : undefined;
    this.protected_analysis = data.protected_analysis ? data.protected_analysis : undefined;


    this.original_description   = data.original_description ? new FundDescription(data.original_description) : undefined;
    this.benchmark_description  = data.benchmark_description ? new FundDescription(data.benchmark_description) : undefined;
    this.components_description = data.components_description ? data.components_description.map((description) => {
      return new FundDescription(description);
    }) : undefined;
  }

}
